<template>
  <form-wizard class="mt-12" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">

    <tab-content title="Contact & General" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Supplier Company Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Address</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Supplier Fax</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Email</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier website</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Supplier Technical Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Technical Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Technical Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Supplier Commercial Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Commercial Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Commercial Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Supplier Emergency Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Emergency Position</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Supplier Emergency Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Product Liability Insurance Cover</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">GFSI Accreditation</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">GFSI Accreditation name eg:BRC</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">GFSI Accreditation File</small>
            <vs-input  type="file" class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Last Audit Grade</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Last Audit Certification Body</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Certification</small>
            <vs-input  type="file" class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Other Accreditation Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Other Accreditation</small>
            <vs-input type="file"  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Sedex Member</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Sedex Member Status</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Manufacturing Site Details" class="mb-5" icon="feather icon-box">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Site Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Address</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Fax</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Email</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Website</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Technical Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Position</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Emergency Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Employee Details" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Site Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Address</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Fax</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Email</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Website</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Technical Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Technical Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Technical Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Commercial Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Commercial Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label">Manufacturing Commercial Mobile</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Position</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Contact Name</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Position</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <small class="label"> Emergency Telephone</small>
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Manufacturing Site Details" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">

            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">

            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Quality Management System" class="mb-5" icon="feather icon-home">
      <vx-card>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
          <div class="vx-col w-1/3">
            <vs-input  class="w-full required" label="" v-model="quantity"/>
          </div>
        </div>
      </vx-card>
    </tab-content>
    <tab-content title="Environmental" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="Ethical" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="Ellergens" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
    <tab-content title="HACCP" class="mb-5" icon="feather icon-home">
      <vx-card>
        Hello
      </vx-card>
    </tab-content>
<!--    <tab-content title="Hygiene" class="mb-5" icon="feather icon-home">-->
<!--      <vx-card>-->
<!--        Hello-->
<!--      </vx-card>-->
<!--    </tab-content>-->
<!--    <tab-content title="Pest Control" class="mb-5" icon="feather icon-home">-->
<!--      <vx-card>-->
<!--        Hello-->
<!--      </vx-card>-->
<!--    </tab-content>-->
<!--    <tab-content title="Transport and Storage" class="mb-5" icon="feather icon-home">-->
<!--      <vx-card>-->
<!--        Hello-->
<!--      </vx-card>-->
<!--    </tab-content>-->
  </form-wizard>
</template>

<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    export default {
        name: "SupplierRegister",
      methods: {
        formSubmitted() {

        }
      },
      components: {
        FormWizard,
        TabContent
      }
    }
</script>

<style scoped>

</style>
